import { render } from "./details-2.vue?vue&type=template&id=0c61bd98"
import script from "./details-2.vue?vue&type=script&lang=js"
export * from "./details-2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__